var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "appbar" }, [
    _c("div", { staticClass: "card-group" }, [
      _c("div", { staticClass: "card login" }, [
        _c(
          "div",
          { staticClass: "login--body" },
          [
            _c("h1", [_vm._v("Получение кода восстановления пароля")]),
            _c("span", { staticClass: "login__title" }, [
              _vm._v("Введите e-mail своего аккаунта"),
            ]),
            _c("span", { staticClass: "login__text" }, [
              _vm._v("На указанный e-mail придет код восстановления"),
            ]),
            _c(
              "el-form",
              { ref: "form", attrs: { model: _vm.model, rules: _vm.rules } },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "email" } },
                  [
                    _c(
                      "el-input",
                      {
                        attrs: { placeholder: "E-mail" },
                        model: {
                          value: _vm.model.email,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "email", $$v)
                          },
                          expression: "model.email",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-user",
                          attrs: { slot: "prepend" },
                          slot: "prepend",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { loading: _vm.loading, type: "primary" },
                        on: { click: _vm.onSubmit },
                      },
                      [_vm._v("Отправить ")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "login__found",
                        on: { click: _vm.toMainPage },
                      },
                      [_vm._v("Вернуться на главную")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }